import {
  ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output
} from '@angular/core';
import { Subject } from 'rxjs/Subject';
import { Observable } from 'rxjs/Observable';

@Component({
  selector: 'tx-auto-complete',
  templateUrl: './tx-auto-complete.component.html',
  styleUrls: ['./tx-auto-complete.component.css']
})
export class TxAutoCompleteComponent implements OnInit {
  @Output() txOnItemSelect: EventEmitter<any> = new EventEmitter();
  @Output() txOnInput: EventEmitter<any> = new EventEmitter();
  @Input() items: Array<any>;
  @Input() emptyListText: string;
  @Input() label: string;
  @Input() attributesTree: Array<string>;
  @Input() performFilterInternally: boolean;
  @Input() typedValue = '';
  @Input() disabled = false;
  @Input() cleanFieldAfterSelect = false;
  @Input() id = null;
  @Input() loadingLabel = 'Carregando...';
  maxResults = 50;
  isOnFocus = false;
  selectedItem: any;
  filteredItems: Array<any>;
  inputObserver: Subject<any>;
  inputId: number;
  @Input() dropdownId: number;

  constructor(private _changeDetector: ChangeDetectorRef) {
    this.setEmptyEntities();
    this.setRandomId();
    this.setUpObservers();
  }

  ngOnInit() {
  }

  inputOnFocus() {
    this.isOnFocus = true;
    this.filterItems();
  }

  inputOnBlur() {
    this.isOnFocus = false;
  }

  performActionsOnInput(keyboardEvent: any) {
    this.setTypedValue(keyboardEvent.target.value);
    this._changeDetector.detectChanges();
    this.onInput();
  }

  selectItem(item) {
    const readableItem = this.getReadableValue(item);
    const readableSelected = this.getReadableValue(this.selectedItem);
    if (readableItem !== readableSelected) {
      this.updateAutoCompleteState(readableItem, item);
      this.cleanAfterSelect();
    }
  }

  getReadableValue(item) {
    return item ? (this.attributesTree ? this.inspectObjectToGetValue(item) : item) : '';
  }

  inspectObjectToGetValue(object) {
    let value = object;
    for (const field of this.attributesTree) {
      value = value[field];
    }
    return value;
  }

  filterItems() {
    if (this.performFilterInternally) {
      this.createNewItemsList();
    }
  }

  createNewItemsList() {
    this.filteredItems = this.assembleFilteredItems();
  }

  assembleFilteredItems() {
    const tempItems = new Array();
    for (const item of this.items) {
      if (this.firstStartsWithAndContainsSecondIgnoreCase(this.getReadableValue(item), this.typedValue)) {
        if (tempItems.length < this.maxResults) {
          tempItems.push(item);
        } else {
          break;
        }
      }
    }
    return tempItems;
  }

  firstStartsWithAndContainsSecondIgnoreCase(first, second) {
    return first.toLowerCase().startsWith(second.charAt(0).toLowerCase())
      && first.toLowerCase().includes((second.toLowerCase()));
  }

  getCleanLabel() {
    return this.label.split('')[0];
  }

  private cleanAfterSelect() {
    if (this.cleanFieldAfterSelect) {
      this.typedValue = '';
      this.filteredItems = new Array();
    }
  }

  private setEmptyEntities() {
    this.items = new Array();
    this.filteredItems = new Array();
    this.inputObserver = new Subject();
  }

  private setUpObservers() {
    this.inputObserver
      .map((event: any) => event)
      .debounceTime(750)
      .distinctUntilChanged()
      .flatMap(search => Observable.of(search).delay(500))
      .subscribe(event => this.performCorrectSearch(event));
  }

  private performCorrectSearch(event) {
    if (this.performFilterInternally) {
      this.typedValue = event.target.value;
      this.filterItems();
    } else {
      this.performActionsOnInput(event);
    }
  }

  private updateAutoCompleteState(readable, item) {
    this.typedValue = readable;
    this.selectedItem = item;
    this.txOnItemSelect.emit(item);
    this.onInput();
  }

  private onInput() {
    if (this.typedValue && this.typedValue !== '') {
      this.txOnInput.emit(this.typedValue);
    }
  }

  private setTypedValue(value) {
    this.typedValue = value;
  }

  private setRandomId() {
    this.inputId = this.inputId || Math.floor((Math.random() * 1000) + 1);
    this.dropdownId = this.dropdownId || Math.floor((Math.random() * 1000) + 1);
  }

}



// WEBPACK FOOTER //
// /home/jenkins/workspace/production-argos-front/argos/src/app/shared/component/tx-auto-complete/tx-auto-complete.component.ts